import { defineMessages } from 'react-intl';


const GIC_MESSAGES = defineMessages({
    gicTermNameShort: {
        id: 'gics.term.name.short',
        defaultMessage: `{term, select,
            1 {{term}-mo}
            3 {{term}-mo}
            4 {{term}-mo}
            6 {{term}-mo}
            other {{years}-yr}
        }`,
    },
});

export default GIC_MESSAGES;
